/**
 * When set, `/onboarding` does not auto-forward to `session.nextUrl` so the user can
 * re-select Quick vs Full (Back from SCM, or Path in the stepper).
 */
export const ONBOARDING_RECHOOSE_QUERY = 'rechoose';
export const ONBOARDING_RECHOOSE_VALUE = '1';

export function getOnboardingPathReselectUrl(): string {
  return `/onboarding?${ONBOARDING_RECHOOSE_QUERY}=${ONBOARDING_RECHOOSE_VALUE}`;
}

export function getOnboardingRoutes(path: string = 'full') {
  return {
    scm: `/onboarding/${path}/scm`,
    repositories: `/onboarding/${path}/repos`,
    features: `/onboarding/${path}/features`,
    workItems: `/onboarding/${path}/workitems`,
    policies: `/onboarding/${path}/policies`,
    standards: `/onboarding/${path}/standards`,
    mcp: `/onboarding/${path}/mcp`,
    reporting: `/onboarding/${path}/reporting`,
    summary: `/onboarding/${path}/summary`,
  };
}

export const ONBOARDING_ROUTES = getOnboardingRoutes('full');

export type OnboardingStepKey = keyof typeof ONBOARDING_ROUTES;
